import { 
  Shield, 
  Wifi, 
  Zap, 
  Settings, 
  Clock, 
  RotateCcw,
  TrendingUp,
  Users
} from 'lucide-react';

const WhyNexxSection = () => {
  const benefits = [
    {
      icon: Shield,
      title: 'Secure Solutions',
      description: 'Enterprise-grade security with multiple layers of protection and compliance standards.'
    },
    {
      icon: Wifi,
      title: 'Direct to Backbone',
      description: 'No brokers. No resellers. Just direct ISP relationships and the performance that comes with it.'
    },
    {
      icon: Zap,
      title: 'High Performance',
      description: 'Optimized infrastructure delivering consistently fast performance and reliability.'
    },
    {
      icon: Settings,
      title: 'Customized Configurations',
      description: 'Tailored solutions designed specifically for your unique business requirements.'
    },
    {
      icon: Clock,
      title: 'Always Available Support',
      description: 'Round-the-clock monitoring and support to ensure maximum uptime and availability.'
    },
    {
      icon: RotateCcw,
      title: 'Flexible Options',
      description: 'Scalable plans that grow with your business, from startup to enterprise level.'
    },
    {
      icon: TrendingUp,
      title: 'Scalable Pricing',
      description: 'Pricing scales with you so you\'re never locked into a static figure that doesn\'t change as you grow.'
    },
    {
      icon: Users,
      title: 'Dedicated Resources',
      description: 'We ethically source and provide access to resources dedicated to ensuring your success.'
    }
  ];

  return (
    <section className="py-12 bg-gray-50 relative overflow-hidden section-drift">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            We are designed to deliver. Backed by <span className="text-nexx-green drop-shadow-[0_0_10px_rgba(34,197,94,0.8)] animate-pulse">engineers</span>.
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From edge to core, we build to scale, secure, and support—without the noise.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="group p-4 bg-white rounded-lg border border-gray-200 hover:border-nexx-green hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="mb-3">
                <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center group-hover:bg-nexx-green group-hover:scale-110 transition-all duration-300">
                  <benefit.icon className="h-5 w-5 text-nexx-green group-hover:text-white transition-colors duration-300" />
                </div>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1 group-hover:text-nexx-green transition-colors duration-300">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-xs leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNexxSection;
